module.exports = __webpack_public_path__ + "img/icon3.bbabcfa3.png";